import { zql } from '../schema.js';
/** The GFR used for doses: newest sample date, and the last entered one when several share that date. */
export function inUseGfrQuery(patientId) {
    return zql.patientGfrs
        .where('patientId', '=', patientId)
        .where('deletedAt', 'IS', null)
        .orderBy('labTime', 'desc')
        .orderBy('createdAt', 'desc')
        .limit(1)
        .one();
}
//# sourceMappingURL=patient-gfr.js.map